export default "__VITE_ASSET__euiDlJEw__"